import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ngxCmArrayMap'
})
export class ArrayMapPipe implements PipeTransform {

  transform(value: Array<any>, args?: any): any {
    return value.map(v => {
      let obj = {};
      for (let key in args) {
        obj[key] = v[args[key]]
      }
      return obj;
    });
  }

}
